import { type Coverage, CoverageType } from "types/quote-types";

export const hasTripCancellationCoverage = (coverages: Coverage[]): boolean =>
  typeof coverages?.find(
    (coverage) =>
      coverage.coverageType === CoverageType.tripCancellation &&
      coverage.isSelected,
  ) !== "undefined";
